<h3 class="subheader">{{ labels?.stellar?.confirmation?.nextSteps }}:</h3>
<div class="items">
  <div
    [ngClass]="calledFrom === '' ? 'item' : 'status-item'"
    *ngFor="let i of items; let idx = index"
  >
    <div class="ts-42 ts-md-52 fw-900 item-index">{{ idx + 1 }}</div>
    <div class="item-content">
      <p
        class="ts-16 ts-md-20 fw-300 mb-30 item-description"
        [innerHTML]="i.description"
      ></p>
      <div *ngIf="i.subItems">
        <ul *ngFor="let i of i.subItems">
          <li
            class="ts-16 ts-md-20 fw-300 mb-30 item-description"
            [innerHTML]="i.description"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</div>
